module.exports = __webpack_public_path__ + "img/mob_logo.fd9802c1.png";